import React, { memo, useCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { initUploadInput } from 'reactApp/appHelpers/appHelpers';
import { closePopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { setUploadFromAction } from 'reactApp/modules/upload/upload.module';
import { setIsOpening } from 'reactApp/modules/viewer/viewer.module';

import styles from './UploadInput.css';

export const UploadInput = memo(({ inputName }: { inputName: string }) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const dispatch = useDispatch();

    useEffect(() => initUploadInput(inputRef.current), []);

    const onClick = useCallback(() => {
        dispatch(setUploadFromAction(inputName));
    }, [dispatch, inputName]);

    const onChange = useCallback(() => {
        dispatch(setIsOpening(false));
        closePopupHelper(popupNames.MOBILE_OPTIONS);
    }, [dispatch]);

    return (
        <div className={styles.root} onClick={onClick}>
            <input type="file" multiple className={styles.input} ref={inputRef} onChange={onChange} />
        </div>
    );
});

UploadInput.displayName = 'UploadInput';
